import React from 'react'
import PlacedStudentProfile from "../PlacedStudents/PlacedStudentProfile"

import StudentReviews from "../PlacedStudents/StudentReviews"

function PlacementSection() {
  return (
    <div>
<PlacedStudentProfile/>

<StudentReviews/>
    </div>
  )
}

export default PlacementSection